import { render, staticRenderFns } from "./AppInputIconPicker.vue?vue&type=template&id=63b9a236&scoped=true&"
import script from "./AppInputIconPicker.vue?vue&type=script&lang=js&"
export * from "./AppInputIconPicker.vue?vue&type=script&lang=js&"
import style0 from "./AppInputIconPicker.vue?vue&type=style&index=0&id=63b9a236&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b9a236",
  null
  
)

export default component.exports